// Çek Defterleri sayfası kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'finance.checkBooks';

export const checkBooksGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Çek Defterleri nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Bankadan aldığınız çek defterlerini ve yapraklarının ne kadarının kullanıldığını buradan izlersiniz. Verilen çek yazarken defter ve sıradaki yaprak bu kayıtlardan gelir. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    stats: t(`${G}.regions.stats`, 'Özet kartları'),
    filters: t(`${G}.regions.filters`, 'Arama'),
    toolbar: t(`${G}.regions.toolbar`, 'Yeni Çek Defteri'),
    table: t(`${G}.regions.table`, 'Defter listesi'),
  },
  steps: [
    {
      region: 'toolbar',
      title: t(`${G}.s1.title`, '1. Yeni defter ekleyin'),
      text: t(`${G}.s1.text`, '"Yeni Çek Defteri" ile bankadan aldığınız defteri tanımlayın. Yenile listeyi tazeler. Sayfaya bir banka hesabından geldiyseniz yalnız o hesabın defterleri görünür; "Tümünü Göster" filtreyi kaldırır.'),
    },
    {
      region: 'stats',
      title: t(`${G}.s2.title`, '2. Özet kartlarını okuyun'),
      text: t(`${G}.s2.text`, 'Toplam Defter, Aktif Defter, Kalan Yaprak ve Kullanılan Yaprak kartları listedeki defterleri özetler. Filtreli görünümde yalnız o hesabın defterleri sayılır.'),
    },
    {
      region: 'filters',
      title: t(`${G}.s3.title`, '3. Defteri bulun'),
      text: t(`${G}.s3.text`, 'Arama kutusu seri numarası, banka adı, alt hesap adı ve açıklamada arar.'),
    },
    {
      region: 'table',
      title: t(`${G}.s4.title`, '4. Yaprak durumunu izleyin'),
      text: t(`${G}.s4.text`, 'Yaprak Durumu sütunu kullanılan / toplam yaprağı, yüzdeyi ve kalan yaprak sayısını gösterir. Çubuk %75\'e kadar yeşil, %75 ve üstünde turuncu, defter dolunca kırmızıdır. Sıradaki No sütunu defter dolunca "Tükendi" yazar.'),
      tips: [
        t(`${G}.s4.tip1`, 'Durum: Aktif, Pasif veya Tamamlandı (tüm yapraklar kullanıldı). Pasif defterler soluk görünür ve çek yazarken listelenmez.'),
        t(`${G}.s4.tip2`, 'Her verilen çek kaydı defterden bir yaprak kullanır. Çek silinse veya iptal edilse de yaprak deftere geri dönmez.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s5.title`, '5. Satır işlemlerini (⋮) kullanın'),
      text: t(`${G}.s5.text`, 'Satır sonundaki ⋮ düğmesi Yapraklar, Düzenle ve Sil seçeneklerini açar. Yapraklar defterin yaprak sayfasını açar; Düzenle seri no, açıklama ve aktiflik bilgisini değiştirir.'),
      tips: [
        t(`${G}.s5.tip1`, 'Sil yalnız hiç yaprağı kullanılmamış defterde açıktır ("Kullanılmış defter silinemez"). Silme onay ister ve geri alınamaz.'),
        t(`${G}.s5.tip2`, 'Kullanılmış bir defteri artık kullanmak istemiyorsanız silmek yerine Düzenle\'den pasife alın. Başlıktaki (i) düğmesi bu rehberi yeniden açar.'),
      ],
    },
  ],
});
